import React from 'react';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import Separator from '../../../core/layout/Separator';
import Tabs from '../../../core/layout/Tabs';
import PlacementTestReportFilterContainer from './PlacementTestReportFilterContainer';
import PlacementTestReportGlobalTabContainer from './PlacementTestReportGlobalTabContainer';
import PlacementTestReportStudentsTab from './PlacementTestReportStudentsTab';

export default function PlacementTestReportScene() {
  return (
    <div>
      <Breadcrumb
        crumbs={[
          {
            text: 'Placement Test Report',
          },
        ]}
      />
      <PlacementTestReportFilterContainer />
      <Separator />
      <Tabs
        tabs={[
          {
            title: 'Global',
            key: 'global',
            content: <PlacementTestReportGlobalTabContainer />,
          },
          {
            title: 'Students',
            key: 'students',
            content: <PlacementTestReportStudentsTab />,
          },
        ]}
      />
    </div>
  );
}
